import api from '../../Axios'; // Adjust path to your Axios instance

// 🟢 FINAL STEP: Submit Doctor Onboarding Agreement
// Endpoint: /api/experts/doctor/onboard
export const onboardDoctor = async (data: {
  expertCode: string;
  isAgreementSigned: boolean;
  isAcknowledged: boolean;
}) => {
  return api.post('/api/experts/doctor/onboard', data);
};